// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edgebutton {
    width: 20px;
    height: 20px;
    background: #eee;
    border: 1px solid #fff;
    cursor: pointer;
    border-radius: 50%;
    font-size: 12px;
    line-height: 1;
}

.edgebutton:hover {
    background: #5e35b1;
    color: #eee;
    box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.08);
}

.edgebutton-foreignobject div {
    background: transparent;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 40px;
}

.reactflow-parent-wrapper {
    display: flex;
    flex-grow: 1;
    height: 100%;
}

.reactflow-parent-wrapper .reactflow-wrapper {
    flex-grow: 1;
    height: 100%;
}

.node-ai-chat {
    /* position: relative;
    margin-top: 84vh; */
    z-index: 100000;
    background-color: gainsboro;
    /* margin-top: 82vh; */
    /* margin-left: 35vw;
    margin-right: 35vw; */
}

.box-inline {
    display: inline-block !important;
}

.codejareditor {
    background: #222 !important;
    border-radius: 6px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
    font-family: "Source Code Pro", monospace;
    font-size: 14px;
    font-weight: 400;
    height: 77vh;
    letter-spacing: normal;
    line-height: 20px;
    padding: 10px;
    -moz-tab-size: 4;
      -o-tab-size: 4;
         tab-size: 4;
}


@media (min-width: 900px)
{
    .css-1equabv-MuiGrid-root {
        max-width: 24% !important
    }
}

.no-scrollbar::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge, and Firefox */
  .no-scrollbar {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}`, "",{"version":3,"sources":["webpack://./src/views/canvas/index.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,2CAA2C;AAC/C;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI;uBACmB;IACnB,eAAe;IACf,2BAA2B;IAC3B,sBAAsB;IACtB;yBACqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,+GAA+G;IAC/G,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;IACb,gBAAW;MAAX,cAAW;SAAX,WAAW;AACf;;;AAGA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;EACf;EACA,6CAA6C;EAC7C;IACE,wBAAwB,GAAG,gBAAgB;IAC3C,qBAAqB,GAAG,YAAY;AACxC","sourcesContent":[".edgebutton {\n    width: 20px;\n    height: 20px;\n    background: #eee;\n    border: 1px solid #fff;\n    cursor: pointer;\n    border-radius: 50%;\n    font-size: 12px;\n    line-height: 1;\n}\n\n.edgebutton:hover {\n    background: #5e35b1;\n    color: #eee;\n    box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.08);\n}\n\n.edgebutton-foreignobject div {\n    background: transparent;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 40px;\n}\n\n.reactflow-parent-wrapper {\n    display: flex;\n    flex-grow: 1;\n    height: 100%;\n}\n\n.reactflow-parent-wrapper .reactflow-wrapper {\n    flex-grow: 1;\n    height: 100%;\n}\n\n.node-ai-chat {\n    /* position: relative;\n    margin-top: 84vh; */\n    z-index: 100000;\n    background-color: gainsboro;\n    /* margin-top: 82vh; */\n    /* margin-left: 35vw;\n    margin-right: 35vw; */\n}\n\n.box-inline {\n    display: inline-block !important;\n}\n\n.codejareditor {\n    background: #222 !important;\n    border-radius: 6px;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);\n    font-family: \"Source Code Pro\", monospace;\n    font-size: 14px;\n    font-weight: 400;\n    height: 77vh;\n    letter-spacing: normal;\n    line-height: 20px;\n    padding: 10px;\n    tab-size: 4;\n}\n\n\n@media (min-width: 900px)\n{\n    .css-1equabv-MuiGrid-root {\n        max-width: 24% !important\n    }\n}\n\n.no-scrollbar::-webkit-scrollbar {\n    display: none;\n  }\n  /* Hide scrollbar for IE, Edge, and Firefox */\n  .no-scrollbar {\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
